import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';

import OffSidebarAcessibilidade from './OffSidebarAcessibilidade.jsx';
import OffSidebarLogin from './OffSidebarLogin.jsx';
import OffSidebarModulo from './OffSidebarModulo.jsx';
import OffSidebarUsuario from './OffSidebarUsuario.jsx';

class OffSidebar extends React.Component {
  static propTypes = {
    hideTrocarEntidade: PropTypes.bool,
    showModulos: PropTypes.bool,
    showLogin: PropTypes.bool
  };

  componentDidMount() {
    $(document).mouseup(function (e) {
      const container = $('.features-group aside');

      if (
        !container.is(e.target) &&
        container.has(e.target).length === 0 &&
        container.hasClass('active')
      ) {
        container.removeClass('active');
        $('.header-features li').removeClass('active');
      }
    });
  }

  render() {
    return (
      <div className="new features-group">
        <OffSidebarUsuario hideTrocarEntidade={this.props.hideTrocarEntidade} />
        <OffSidebarAcessibilidade />
        {this.props.showModulos && <OffSidebarModulo />}
        {this.props.showLogin && <OffSidebarLogin />}
      </div>
    );
  }
}

export default OffSidebar;
